import { useState } from "react";
import { Row, Space, Button } from "@masterteam/mt-design-react";
import AsyncImg from "../AsyncImg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete.svg";
import { ReactComponent as DownloadIcon } from "../../assets/images/download.svg";
import attachmentIcon from "../../assets/images/attachments/attachment.svg";
import pdfIcon from "../../assets/images/attachments/pdf.svg";
import wordIcon from "../../assets/images/attachments/word.svg";
import excelIcon from "../../assets/images/attachments/excel.svg";
import powerpointIcon from "../../assets/images/attachments/powerpoint.svg";
import textIcon from "../../assets/images/attachments/text.svg";
import { downloadFile } from "../../helpers/attachments";
import styles from "./Attachments.module.scss";

const imageTypes = ["jpg", "jpeg", "gif", "png", "bmp", "svg"];

const initialLoading = {
  delete: false,
  download: false
};

const Attachment = ({ file, onDelete }) => {
  const [loading, setLoading] = useState(initialLoading);
  if (!file) return null;

  const getImage = () => {
    const type =
      file.extension?.toLowerCase() || /[^.]+$/.exec(file.FileName)[0];
    if (imageTypes.includes(type) && file.preview) {
      return (
        <img src={file.preview} name={file.FileName} alt={file.FileName} />
      );
    }
    switch (true) {
      case type === "pdf":
        return <img src={pdfIcon} alt={file.name} />;
      case type === "doc" || type === "docx":
        return <img src={wordIcon} alt={file.name} />;
      case type === "txt":
        return <img src={textIcon} alt={file.name} />;
      case type === "xls" || type === "xlsx":
        return <img src={excelIcon} alt={file.name} />;
      case type === "ppt" || type === "pptx":
        return <img src={powerpointIcon} alt={file.name} />;
      case imageTypes.indexOf(type) >= 0:
        return <AsyncImg file={file} />;
      default:
        return <img src={attachmentIcon} alt={file.name} />;
    }
  };

  const handleDelete = e => {
    e.stopPropagation();
    setLoading({ ...loading, delete: true });
    onDelete(file).then(() => {
      setLoading({ ...loading, delete: false });
    });
  };

  const handleDownload = e => {
    e.stopPropagation();
    setLoading({ ...loading, download: true });
    downloadFile(file).finally(() =>
      setLoading({ ...loading, download: false })
    );
  };

  return (
    <Row
      className={styles.attachment}
      size="small"
      align="center"
      justify="between"
    >
      <Space align="center">
        <div className={styles.thumb}>{getImage()}</div>
        <span className={styles.name}>{file.FileName}</span>
      </Space>
      <Space gap={2}>
        {file.ID ? (
          <Button
            shape="circle"
            variant="primary"
            fill="none"
            Icon={DownloadIcon}
            onClick={handleDownload}
            disabled={loading.delete}
            loading={loading.download}
          />
        ) : null}
        {onDelete ? (
          <Button
            shape="circle"
            variant="error"
            fill="none"
            Icon={DeleteIcon}
            onClick={handleDelete}
            disabled={loading.download}
            loading={loading.delete}
          />
        ) : null}
      </Space>
    </Row>
  );
};

export default Attachment;
